import React from 'react';
import EmptyStateSVG from 'assets/empty_state_resource_mapper.svg?react';
import ClockIcon from 'assets/clock_icon.svg?react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';
import { DataState } from 'views/ResourceMapper/ResourceMapperView';
import EmptyStateNoDataSVG from 'assets/empty_state_resource_mapper_no_data.svg?react';
import PlusIcon from 'assets/PlusSign.svg?react';
import { useHistory } from 'react-router-dom';

type EmptyViewProps = {
  emptyMessage?: any;
  emptyDetails?: any;
  paddingTop?: string;
  emptyState: DataState;
};

const EmptyView = ({ emptyMessage, emptyDetails, paddingTop, emptyState }: EmptyViewProps) => {
  const { t } = useTranslation();
  const emptyImageSvg =
    emptyState === DataState.NO_DATA_TO_MAP ? <EmptyStateSVG /> : <EmptyStateNoDataSVG />;
  const history = useHistory();

  const handleUploadOperation = () => {
    history.push('/file-upload');
  };

  return (
    <div
      data-cy="empty_view"
      data-testid="empty_view"
      className="w-100% h-100% flex items-center justify-center"
    >
      <div className="flex flex-col text-center w-100% items-center mt-200">
        {emptyImageSvg}
        <h4 className="text-20 font-bold leading-32px mt-80">
          {t(emptyMessage ?? 'resource-mapper.no_data_action')}
        </h4>
        <p className="text-16 font-normal leading-24px w-60% mt-4 text-gray-subtitle">
          {emptyDetails && t(emptyDetails)}
        </p>

        {emptyState === DataState.NO_DATA_TO_MAP ? (
          <div className="mt-20">
            <Button
              data-cy="add_location"
              data-testid="add_location"
              type={ButtonType.outline}
              size="large"
              className="w-260px"
              icon={<ClockIcon />}
            >
              <span className={'pl-4'}>{t('resource-mapper.data_mapping_history')}</span>
            </Button>
          </div>
        ) : (
          <div className="mt-20" style={{ display: 'flex' }}>
            <Button
              data-cy="resource-mapper-file-upload-operation-btn"
              data-testid="resource-mapper-file-upload-operation-btn"
              type={ButtonType.primary}
              size="large"
              className="w-260px"
              icon={<PlusIcon fill="white" />}
              onClick={handleUploadOperation}
            >
              <span
                style={{
                  justifyContent: 'space-around !important',
                  display: 'flex !important',
                  flexWrap: 'nowrap',
                  flexDirection: 'row',
                  alignItems: 'center',
                  color: 'white',
                  paddingLeft: '5px',
                }}
              >
                {t('resource-mapper.file_upload_operation_btn')}
              </span>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmptyView;
